(() => {
  const setup = (root = document) => {
    const wraps = root.querySelectorAll('.video-wrap');

    wraps.forEach((wrap) => {
      const video = wrap.querySelector('video');
      const btn = wrap.querySelector('[data-pf-vid-toggle]');
      if (!video || !btn) return;

      const setUI = (isPlaying) => {
        btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      };

      const reflect = () => setUI(!video.paused && !video.ended);

      if (video.readyState >= 2) {
        reflect();
      } else {
        video.addEventListener('playing', reflect, { once: true });
        video.addEventListener('pause', reflect, { once: true });
        video.addEventListener('loadeddata', reflect, { once: true });
      }

      btn.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => setUI(true)).catch(() => setUI(false));
        } else {
          video.pause();
          setUI(false);
        }
      });

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.25) {
              if (!video.paused) {
                video.pause();
                setUI(false);
              }
            }
          });
        },
        { threshold: [0, 0.25, 1] }
      );
      io.observe(video);

      let resizeTO;
      const onResize = () => {
        clearTimeout(resizeTO);
        resizeTO = setTimeout(() => {
          if (!video.paused) {
            video.pause();
            setUI(false);
          }
        }, 150);
      };
      window.addEventListener('resize', onResize, { passive: true });

      wrap.addEventListener('pf:cleanup', () => {
        io.disconnect();
        window.removeEventListener('resize', onResize);
      });
    });
  };

  const init = () => setup(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => setup(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target
      .querySelectorAll('.video-wrap')
      .forEach((wrap) => wrap.dispatchEvent(new CustomEvent('pf:cleanup')));
  });
})();
